import { withGalleryGreetingsProps } from 'viewModel/gallery/withGalleryGreetingsProps';
import GalleryGreetings from 'components/Community/GalleryGreetings/GalleryGreetings';

export default withGalleryGreetingsProps(GalleryGreetings);
